import { Base } from '../Base';

export class SystemXDashboard extends Base {

     FacilityMasterID?: number;
     FacilityNumber ?: string;
     FacilityName ?: string;
     Modality?: string;
     FacilityTypeLKID?: number;
     FacilityTypeLK?: string;
     FacilityIsActiveFlag?: string;
     RegionMasterID?: number;
     RegionNumber?: string;
     RegionName?: string;
     DivisionMasterID?: number;
     DivisionNumber?: string;
     DivisionName?: string;
     GroupNumber?: string;
     GroupName?: string;
     Address1?: string;
     City?: string;
     State?: string;
     Zip?: string;
     Phone ?: string;

}

export class SystemXDashboardResponse extends Base {
    response?: Array<SystemXDashboard>;
    constructor() {
        super();
    }
}

export class SystemXDashboardAPC extends Base {

        FacilityMasterID?: number;      
        FacilityNumber?: string;  
        FacilityName?: string;  
        EquipmentID?: number;  
        EquipmentSerialNumber?: number;  
        EquipmentDescription?: string;  
        EquipmentSubTypeCode?: string;  
        Mobile_EquipmentSerialNum?: string; 
        LastknowDisinfection?: string;  
        DaysSinceChemicalDisinfection?: number;
        HoursSinceLastknownDisinfection?: number;  
        LastknowDisinfectionType?: string;  
        PACLabel?: string;  
        PACResult?: string;  
        PACStatusColor?: string;  
        EquipmentStatusColor?: string;  
        TotalPAC?: number;  
        PACNeeded?: number;  


}

export class SystemXDashboardAPCResponse extends Base {
   response?: Array<SystemXDashboard>;
   constructor() {
       super();
   }
}
